import React, { useRef, useState } from 'react'
import { Toast } from 'primereact/toast'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { PopupContext, PopUpContextType } from '../../_core/contexts/popToast'
import EditableArea from '../../pages/auth/_forms/_components/EditableArea'


interface webReportDialog {
  isDialogVisible: boolean
  openDialog: () => void
  closeDialog: () => void
  reportReason: string
  setReportReason: (reason: string) => void
  handleReport: (_: string) => void
  handleBlock: () => void
  errors: string | undefined
}

export default function ReportUser(props: webReportDialog) {
  const { openPopup } = React.useContext<PopUpContextType>(PopupContext)
  const [reportReason, setReportReason] = useState<string>('')
  const [toggle, setToggle] = useState<boolean>(false)
  const toast = useRef<Toast>(null)

  function cancelReport() {
    toggleText()
  }

  function blockProfile() {
    openPopup({ severity: 'info', title: 'Block and Unmatch', text: 'You have blocked and unmatched with this user.', duration: 3000 })
    props.handleBlock()
  }

  function reportProfile() {
    props.handleReport(reportReason)
  }

  const toggleText = () => {
    setToggle(prev => !prev)
    setReportReason('')
  }

  return (
    <>
      <Toast ref={toast} />
      <div className="d-flex justify-content-center">
        <Button label="Block or Report" link size="large" iconPos="right" loadingIcon icon="pi pi-flag-fill" style={{ color: "tomato" }} onClick={props.openDialog} />
      </div>
      <div className="flex justify-content-center">
        <Dialog
          header="Block or Report"
          visible={props.isDialogVisible}
          style={{ width: "100%", maxWidth: "850px", maxHeight: "100%" }}
          onHide={() => { if (!props.isDialogVisible) return; props.closeDialog(), setReportReason("") }}
        >
          <>
            <div className="flex">
              <p className="text-center fw-medium">Your feedback will remain anonymous.</p>
              <div className="d-flex flex-column row-gap-3 rounded mb-5">
                {toggle ? null : <Button
                  label="Block and Unmatch" type="button" className="rounded-2 btn btn-secondary-light w-75 mx-auto"
                  style={{ color: "black" }} severity="info"
                  tooltipOptions={{ position: "top" }} tooltip='Blocked users won"t see you in their search results.'
                  onClick={(blockProfile)}
                >
                </Button>}
                {toggle ? null : <Button
                  label="Suspicious Profile" type="button" className="rounded-2 btn btn-secondary-light w-75 mx-auto"
                  style={{ color: "black" }} severity="info"
                  tooltipOptions={{ position: "top" }} tooltip="With your details our team will investigate."
                  onClick={(toggleText)}
                >
                </Button> }
              </div>
              {toggle ? (
                <div className="w-75 mx-auto">
                  <EditableArea
                    id="reportReason"
                    name="reportReason"
                    autoFocus
                    autoResize
                    label="Please provide any details that may assist us."
                    errors={props.errors}
                    maxLength={255}
                    placeholder="Details... please provide a minimum of 10 characters."
                    rows={4}
                    value={reportReason}
                    onChange={(e) => setReportReason(e)}
                  />
                  <div className="d-flex justify-content-between text-end ">
                    {reportReason.length >= 10 ?
                      <span className="border-1 text-center"><b>Thank you for your feedback. Our team will investigate and take appropriate action.</b></span >
                      : null
                    }
                    <p className="text-end p-1" style={{ fontSize: 12 }}>{reportReason.length}/255</p>
                  </div>
                  <div className="d-flex justify-content-center align-items-center gap-1 my-2 ">
                    <i className="pi pi-exclamation-circle" style={{ color: "orange" }}></i>
                    <span className="text-center">Please confirm to submit the report.</span>
                  </div>
                  <span className="d-flex column-gap-4 justify-content-center">
                    <Button label="Cancel" onClick={(cancelReport)} type="button" className="rounded-2 btn btn-secondary-light"></Button>
                    <Button label="Submit" onClick={(reportProfile)} severity="danger" type="button" className="rounded-2 btn btn-primary-light"></Button>
                  </span>
                </div>
              ) : (
                null)
              }
            </div>
          </>
        </Dialog>
      </div>
    </>
  )
}